import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import RecordWithdrawalRequestUsers from 'views/financial/withdrawalRequests/recordTableWithdrawalRequest'; // Importing a component for displaying withdrawal request users
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for recording withdrawal requests.
 * @extends JetView
 */
export default class recordWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration with pagination and selection options
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting number of items per page
                    options: ['10', '20', '50', '100'], // Options for items per page
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for changing items per page
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default size from development config
                },
            ],
        };

        // Left side configuration with toolbar and user records
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Apply current theme
                    elements: [
                        { width: 100, view: 'label', label: _('Historial') }, // Label for history
                    ],
                },
                RecordWithdrawalRequestUsers, // Component for displaying withdrawal request users
                toolbar, // Include the toolbar defined above
            ],
        };

        // Return the main configuration object for the view
        return {
            scrollY: screen.width < 820 ? false : true, // Enable/disable vertical scrolling based on screen width
            height: screen.width < 820 ? 600 : 0, // Set height based on screen width
            type: 'wide', // Set view type
            cols: [left], // Include the left configuration
        };
    }
}

// FILE DOCUMENTED
